import { Link } from '@lmig/lmds-react-link';
import { FunctionComponent, JSX } from 'react';
import './TileV2.scss';
import { useUserData } from 'Foundation/User/UserContext';
import { Heading } from '@lmig/lmds-react-typography';
import { StringHelper } from 'Utilities/StringHelper';

interface ITile {
  title: string;
  statCode: string;
  headerLinkHref: string;
  headerLinkText: string;
  showStatCode: boolean;
  children: JSX.Element;
}

const Tile: FunctionComponent<any> = (props: ITile) => {
  const { userData } = useUserData();
  var statCode = userData?.selectedStatCodeData?.SubStat;
  const hasLink = props.headerLinkHref?.length > 0 && props.headerLinkText?.length > 0;

  if (props && props.title) {
    return (
      <>
        <div className={'portal-tile-v2-wrapper'}>
          <div className={'portal-tile-v2'}>
            <div className={'portal-tile-v2-header'}>
              <div
                className={
                  hasLink
                    ? 'portal-tile-v2-header-title-container portal-tile-v2-header-title-container-haslink'
                    : 'portal-tile-v2-header-title-container'
                }
              >
                <Heading className="custom-tile-heading-margin" type="h4-light">
                  {props.title}
                </Heading>
                {props.showStatCode && statCode ? (
                  <Heading className="custom-tile-heading-margin tile-agency-code" type="h6">
                    {`(${StringHelper.formatStatCode(statCode)})`}
                  </Heading>
                ) : (
                  <></>
                )}
              </div>
              <div>
                {hasLink ? (
                  <Link
                    target="_blank"
                    href={props.headerLinkHref}
                    variant="standalone"
                    className="portal-tile-v2-header-link"
                  >
                    {props.headerLinkText}
                  </Link>
                ) : null}
              </div>
            </div>

            <div className={'portal-tile-v2-body'}>{props.children}</div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
};

export default Tile;
